<template>
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 37">
      <path id="content_paste_go"
        d="M1.66683 13.9993C1.30016 13.9993 0.986274 13.8688 0.725163 13.6077C0.464052 13.3466 0.333496 13.0327 0.333496 12.666L0.333496 3.33268C0.333496 2.96602 0.464052 2.65213 0.725163 2.39102C0.986274 2.1299 1.30016 1.99935 1.66683 1.99935H4.45016C4.57239 1.61046 4.81127 1.29102 5.16683 1.04102C5.52239 0.791016 5.91127 0.666016 6.3335 0.666016C6.77794 0.666016 7.17516 0.791016 7.52516 1.04102C7.87516 1.29102 8.11127 1.61046 8.2335 1.99935H11.0002C11.3668 1.99935 11.6807 2.1299 11.9418 2.39102C12.2029 2.65213 12.3335 2.96602 12.3335 3.33268V6.66602C12.3335 6.8549 12.2696 7.01324 12.1418 7.14102C12.0141 7.26879 11.8557 7.33268 11.6668 7.33268C11.4779 7.33268 11.3196 7.26879 11.1918 7.14102C11.0641 7.01324 11.0002 6.8549 11.0002 6.66602V3.33268H9.66683V4.66602C9.66683 4.8549 9.60294 5.01324 9.47516 5.14102C9.34739 5.26879 9.18905 5.33268 9.00016 5.33268H3.66683C3.47794 5.33268 3.31961 5.26879 3.19183 5.14102C3.06405 5.01324 3.00016 4.8549 3.00016 4.66602V3.33268H1.66683L1.66683 12.666H5.66683C5.85572 12.666 6.01405 12.7299 6.14183 12.8577C6.26961 12.9855 6.3335 13.1438 6.3335 13.3327C6.3335 13.5216 6.26961 13.6799 6.14183 13.8077C6.01405 13.9355 5.85572 13.9993 5.66683 13.9993H1.66683ZM6.3335 3.33268C6.52239 3.33268 6.68072 3.26879 6.8085 3.14102C6.93627 3.01324 7.00016 2.8549 7.00016 2.66602C7.00016 2.47713 6.93627 2.31879 6.8085 2.19102C6.68072 2.06324 6.52239 1.99935 6.3335 1.99935C6.14461 1.99935 5.98627 2.06324 5.8585 2.19102C5.73072 2.31879 5.66683 2.47713 5.66683 2.66602C5.66683 2.8549 5.73072 3.01324 5.8585 3.14102C5.98627 3.26879 6.14461 3.33268 6.3335 3.33268Z"
        fill="#0CBA4A" />
      <path id="Path 2" d="M8.3335 11.3153L10.5614 13.3333L15.0002 8" stroke="#0CBA4A" stroke-width="2.2"
        stroke-linecap="round" />
    </g>
  </svg>






</template>

<script>
export default {
  name: 'CompleteIcon',
}
</script>

<style lang="scss" scoped></style>